import { appMethod as app } from '@utils/app';
import { getCurrentPageQueryParams, convertLineStyleData } from '@utils/tools';
import { TopNav } from '@common/top-nav/TopNav';
import OfficialPage from '../OfficialPage';

import './IndemnityOrder.less';

export default class IndemnityOrder extends OfficialPage {
  state = {
    orderId: '',
    deliverType: 0,
    indemnityOrderData: {},
    isFromBack: false,
    indemnityExplain: {},
    isShowBtn: true
  }

  constructor(props) {
    super(props);
    document.title = '反馈详情';
  }

  componentWillMount(options = getCurrentPageQueryParams()) {
    this.setData({
      orderId: options.orderId,
      deliverType: options.deliverType
    })
    this.dataInitial()
  }

  componentDidMount() {
    this.dataInitial()
  }

  componentDidHide() { }

  componentWillUnmount() { }

  onPullDownRefresh = () => { }
  onReachBottom = () => { }
  onShareAppMessage = () => { }
  dataInitial = () => {
    this.getTransportIndemnityOrder()
    this.getIndemnityExplainParam()
  }
  getTransportIndemnityOrder = () => {
    var that = this
    app.sendRequest({
      url: '/index.php?r=AppTransport/getTransportIndemnityOrder',
      data: {
        order_id: that.data.orderId
      },
      success: function (res) {
        that.setData({
          indemnityOrderData: res.data
        })
        if (res.data.length > 3) {
          that.setData({
            isShowBtn: false
          })
          return
        }
        for (let i = 0; i < res.data.length; i++) {
          if (res.data[i].status == 1) {
            that.setData({
              isShowBtn: false
            })
            return
          }
        }
      }
    })
  }
  indemnity = () => {
    app.turnToPage(
      '/orderMeal/pages/takeoutFeedback/takeoutFeedback?orderId=' +
      this.data.orderId +
      '&deliverType=' +
      this.data.deliverType
    )
  }
  toBalance = () => {
    app.turnToPage('/eCommerce/pages/balance/balance')
  }
  getIndemnityExplainParam = () => {
    let submitData = {
      order_id: this.data.orderId
    }
    var that = this
    app.sendRequest({
      url: '/index.php?r=AppTransport/getIndemnityExplainParam',
      method: 'post',
      data: submitData,
      success: function (res) {
        that.setData({
          indemnityExplain: res.data
        })
      }
    })
  }
  previewImage = e => {
    var dataset = e.currentTarget.dataset
    app.previewImage({
      current: dataset.src,
      urls: JSON.parse(dataset.previewImgarr)
    })
  }

  render() {
    const {
      rewardPointObj,
      shareGiftsObj,
      collectGiftsObj,
      collectGetObj,
      showGetUserInfo,
      indemnityOrderData,
      indemnityExplain,
      isShowBtn
    } = this.state

    return (
      <div className="official-page indemnity-order">
        <TopNav title="反馈详情" />
        <React.Fragment>
          <div className="container">
            {Object.values(indemnityOrderData).map((item, index) => {
              return (
                <div key className="indemnityItem">
                  {item.status == 1 && (
                    <div className="tips">
                      <div>耐心等待商家处理，一般处理时间在1-3天内</div>
                      <div>
                        {'如果对方长时间不处理，可以拨打电话' +
                          indemnityExplain.contact_phone}
                      </div>
                    </div>
                  )}
                  {(item.status == 2 || item.status == 3) && (
                    <div className="tips">
                      <div>此单投诉历史记录</div>
                    </div>
                  )}
                  <div className="complaints">
                    <div className="complaintsItem">
                      <span style={convertLineStyleData('font-size:30rpx;')}>投诉详情</span>
                    </div>
                    <div className="complaintsItem">
                      <span>反馈项</span>
                      <span className="fr">
                        {item.complaint_data.complaint_reason}
                      </span>
                    </div>
                    {item.complaint_data.complaint_pics && (
                      <div className="complaintsItem">
                        <span>凭证</span>
                        <div className="imageContain">
                          {item.complaint_data.complaint_pics.map(
                            (imgUrl, index) => {
                              return (
                                <React.Fragment key={index}>
                                  <img
                                    src={imgUrl}
                                    onClick={this.previewImage}
                                    data-src={imgUrl}
                                    data-preview-imgarr={
                                      JSON.stringify(item.complaint_data.complaint_pics)
                                    }
                                  />
                                </React.Fragment>
                              )
                            }
                          )}
                        </div>
                      </div>
                    )}
                    {item.complaint_data.complaint_additional_reason && (
                      <div className="complaintsItem">
                        <span>补充信息</span>
                        <span
                          className="fr"
                          style={convertLineStyleData('max-width:500rpx;text-align:right;white-space:pre-line;word-break:break-all;')}
                        >
                          {item.complaint_data.complaint_additional_reason}
                        </span>
                      </div>
                    )}
                    <div className="complaintsItem">
                      <span>提交时间</span>
                      <span className="fr">{item.add_time}</span>
                    </div>
                  </div>
                  <div className="complaints">
                    <div className="complaintsItem">
                      <span>处理情况</span>
                    </div>
                    <div className="complaintsItem">
                      <span>状态</span>
                      <span className="fr">
                        {item.status == 1
                          ? '待处理'
                          : item.status == 2
                            ? '已拒绝'
                            : '已赔付'}
                      </span>
                    </div>
                    {item.handle_data.description && (
                      <div className="complaintsItem">
                        <span>原因</span>
                        <span
                          className="fr"
                          style={convertLineStyleData('max-width:276px;text-align:right;white-space:pre-line;word-break:break-all;')}
                        >
                          {item.handle_data.description}
                        </span>
                      </div>
                    )}
                    {item.status == 3 && (
                      <div className="complaintsItem">
                        <span>赔付金额</span>
                        <div className="fr">
                          {'¥' + item.indemnity_fee + '，请到'}
                          <span style={convertLineStyleData('color: #FF7100;')} onClick={this.toBalance}>
                            交易记录
                          </span>
                          查看
                        </div>
                      </div>
                    )}
                    {item.status != 1 && (
                      <div className="complaintsItem">
                        <span>处理时间</span>
                        <span className="fr">{item.update_time}</span>
                      </div>
                    )}
                  </div>
                </div>
              )
            })}
            {isShowBtn && (
              <div className="indemnityBtn" onClick={this.indemnity}>
                <span>继续反馈</span>
              </div>
            )}
          </div>
        </React.Fragment>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/official-page/indemnity-order/IndemnityOrder.jsx